import React from "react";
import "./Sidebar.css";
import Logo from "../Logo";
import { FaTimes } from "react-icons/fa";
import { navigations } from "../../data";
import { Link as RouterLink } from "react-router-dom";

const Sidebar = ({ openSidebar, onClose }) => {
  return (
    <div className={`sidebar ${openSidebar ? "visible" : ""}`}>
      <div className="sidebar__wrapper">
        <div className="flex__center top">
          <Logo />
          <button className="flex__center icon" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="middle navlinks">
          {navigations.map((nav, index) => renderNavItem(nav, index))}
        </div>
      </div>
    </div>
  );
};

function renderNavItem(item, idx) {
  // don't render a RouterLink when there's no path/to/href
  if (!item || (!item.path && !item.to && !item.href)) return null;

  if (item.path) {
    return (
      <RouterLink key={idx} to={item.path} className="sidebar-link">
        {item.label}
      </RouterLink>
    );
  }

  if (item.to) {
    return (
      <RouterLink key={idx} to={item.to} className="sidebar-link">
        {item.label}
      </RouterLink>
    );
  }

  // external links
  if (item.href) {
    return (
      <a
        key={idx}
        href={item.href}
        className="sidebar-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.label}
      </a>
    );
  }

  return null;
}

export default Sidebar;
